(function() {
    'use strict';
    angular
        .module('ccsTrApp')
        .factory('GpfsBatch', GpfsBatch);

    GpfsBatch.$inject = ['$resource', 'DateUtils'];

    function GpfsBatch ($resource, DateUtils) {
        var resourceUrl =  'api/gpfs-batches/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.batchDate = DateUtils.convertDateTimeFromServer(data.batchDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
